"use client";

import { TarotCard } from "./types";

interface TarotCardDetailProps {
  card: TarotCard;
}

export function TarotCardDetail({ card }: TarotCardDetailProps) {
  return (
    <div className="card-sacred p-5 sm:p-6 mt-6 animate-slide-up max-w-[560px] mx-auto">
      {/* Vedic parallel */}
      <div className="rounded-lg p-4 mb-5 bg-ish-accent-light">
        <p className="text-[11px] font-bold uppercase tracking-[0.15em] mb-1 text-intent-brand">
          Vedic Parallel
        </p>
        <p className="text-body leading-relaxed italic font-serif text-ish-dark">
          {card.vedic_parallel}
        </p>
      </div>

      {/* Keywords */}
      <div className="flex flex-wrap gap-1.5 mb-4">
        {card.keywords.map((kw) => (
          <span
            key={kw}
            className="text-[11px] px-2.5 py-1 rounded-full bg-ish-accent-light text-intent-brand border border-ish-accent-border"
          >
            {kw}
          </span>
        ))}
      </div>

      {/* Meaning */}
      <div className="mb-4">
        <p className="text-[11px] font-bold uppercase tracking-[0.15em] mb-1.5 text-ish-text-muted">
          Meaning
        </p>
        <p className="text-body leading-relaxed text-ish-text">{card.meaning}</p>
      </div>

      {/* Advice */}
      <div className="mb-4">
        <p className="text-[11px] font-bold uppercase tracking-[0.15em] mb-1.5 text-ish-text-muted">
          Guidance
        </p>
        <p className="text-body leading-relaxed font-medium font-serif text-ish-dark">
          &ldquo;{card.advice}&rdquo;
        </p>
      </div>

      {/* Meta — graha, element */}
      <div className="flex gap-4 text-caption text-ish-text-muted">
        {card.vedic_graha && (
          <span>
            Graha: <strong className="text-ish-dark">{card.vedic_graha}</strong>
          </span>
        )}
        {card.vedic_element && (
          <span>
            Tattva: <strong className="text-ish-dark">{card.vedic_element}</strong>
          </span>
        )}
        {card.element && (
          <span>
            Element: <strong className="text-ish-dark">{card.element}</strong>
          </span>
        )}
      </div>
    </div>
  );
}
